export default{
    namespaced: true,

    state:{
        optionTableTrab:{},

        itemsEncuesta:{
            // Va en R41 en campo 3
            0:{
                label:'Comunicación',
                datos:[
                    {id:1, label:"Comparte información de manera efectiva y asertiva", model:"r1"},
                    {id:2, label:"Escucha activamente y es receptivo a las opiniones de los demás", model:"r2"},
                    {id:3, label:"Presta atención en las conversaciones", model:"r3"},
                    {id:4, label:"Se comunica de manera escrita con claridad", model:"r4"},
                    {id:5, label:"Expresa sus ideas con claridad y respeto a la otra persona", model:"r5"},
                    {id:6, label:"Fomenta el diálogo de manera abierta y directa", model:"r6"},

                ],
            },
            1:{
                label:'Trabajo en equipo',
                datos:[
                    {id:7, label:"Se desempeña como un miembro activo del equipo", model:"r7"},
                    {id:8, label:"Inspira, motiva y guía al equipo para el logro de las metas", model:"r8"},
                    {id:9, label:"Comparte su conocimiento, habilidades y experiencia", model:"r9"},
                    {id:10, label:"Comparte el reconocimiento de logros con el resto del equipo", model:"r10"},

                ],
            },
            2:{
                label:'Resolución de problemas',
                datos:[
                    {id:11, label:"Recauda información de diferentes fuentes antes de tomar una decisión", model:"r11"},
                    {id:12, label:"Se enfoca en los asuntos clave para resolver el problema", model:"r12"},
                    {id:13, label:"Tiene flexibilidad y disposición de cambio ante las situaciones", model:"r13"},
                    {id:14, label:"Considera las implicaciones antes de llevar a cabo una acción", model:"r14"},
                    {id:15, label:"Conserva la calma en situaciones complicadas", model:"r15"},

                ],
            },
            3:{
                label:'Mejora continua',
                datos:[
                    {id:16, label:"Se adapta a trabajar con nuevos procesos y tareas", model:"r16"},
                    {id:17, label:"No muestra resistencia a las ideas de las demás personas", model:"r17"},
                    {id:18, label:"Busca activamente nuevas maneras de realizar las actividades", model:"r18"},
                    {id:19, label:"Se esfuerza por innovar y aportar ideas", model:"r19"},
                    {id:20, label:"Busca reforzar sus habilidades y trabajar en sus áreas de oportunidad", model:"r20"},
                    {id:36, label:"Capacidad de recibir críticas constructivas en forma abierta", model:"r36"},
                    {id:37, label:"Capacidad de no ofenderse y aprovechar las críticas para mejorar", model:"r37"},
                    {id:38, label:"Porta el uniforme limpio y completo", model:"r38"},
                    {id:39, label:"Porta el gafete de la empresa", model:"r39"},
                    {id:40, label:"Muestra pulcritud en su apariencia", model:"r40"},
                    {id:41, label:"Es puntual en su horario laboral", model:"r41"},
                ],
            },
            4:{
                label:'Organización y administración del tiempo',
                datos:[
                    {id:21, label:"Es capaz de establecer prioridades en sus tareas laborales", model:"r21"},
                    {id:22, label:"Completa de manera efectiva en tiempo y forma los proyectos asignados", model:"r22"},
                    {id:23, label:"Utiliza eficientemente los recursos asignados para llevar a cabo sus actividades", model:"r23"},

                ],
            },
            5:{
                label:'Enfoque en el cliente',
                datos:[
                    {id:24, label:"Establece y mantiene relación a largo plazo con los clientes al ganar su confianza", model:"r24"},
                    {id:25, label:"Procura la satisfacción del cliente al brindar un servicio de excelencia", model:"r25"},
                    {id:26, label:"Busca nuevas maneras de brindar valor agregado a los clientes", model:"r26"},
                    {id:27, label:"Entiende las necesidades del cliente y busca exceder sus expectativas", model:"r27"},
                    {id:28, label:"Es percibido por el cliente como una persona confiable que representa a la empresa", model:"r28"},

                ],
            },
            6:{
                label:'Pensamiento estratégico',
                datos:[
                    {id:29, label:"Comprende las implicaciones de sus decisiones en el negocio a corto y largo plazo", model:"r29"},
                    {id:30, label:"Determina objetivos y establece prioridades para lograrlos", model:"r30"},
                    {id:31, label:"Tiene visión a largo plazo y busca oportunidades para llevar a la organización al crecimiento", model:"r31"},
                    {id:32, label:"Basa sus decisiones y acciones estratégicas en la misión, visión y valores de la organización", model:"r32"},

                ],
            },
            7:{
                label:'Enfoque a resultados',
                datos:[
                    {id:33, label:"Reconoce y aprovecha las oportunidades", model:"r33"},
                    {id:34, label:"Mantiene altos niveles de estándares de desempeño", model:"r34"},
                    {id:35, label:"Demuestra interés por el logro de metas individuales y organizacionales  con compromiso", model:"r35"},

                ],
            },

        },
    },
    mutations:{
        //CAMBIA_PAGE(state, data){
        //    state.page = data
        //},
        CAMBIA_OPTIONS_TABLE_TRAB(state, data){
            state.optionTableTrab = data
        }
    },
    actions:{
        //
    },
    getters:{
        //
    },
}